import VueQR from './vue-qr.vue'
export default VueQR


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-qr/src/main.js
// module id = X2mQ
// module chunks = 46